import { SelectionModel } from '@angular/cdk/collections';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from '@klickdata/core/message';
import { MessageErrorComponent } from '@klickdata/core/message/src/message-error/message-error.component';
import { SideNaveData } from '@klickdata/core/mobile/src/mobile.service';
import { Notification, NotificationService } from '@klickdata/core/notification';
import { AppScope } from '@klickdata/core/resource';
import { User } from '@klickdata/core/user';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
//TODO: Needs refactoring to handle all cases
@Component({
    selector: 'app-menu-side-send-message',
    templateUrl: './menu-side-send-message.component.html',
    styleUrls: ['./menu-side-send-message.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuSideSendMessageComponent implements OnDestroy, OnInit {
    @Input() public navData: SideNaveData;
    @Output() onClose: EventEmitter<boolean> = new EventEmitter();
    public messageForm: FormGroup;
    AppScope = AppScope;
    @Output() saving: EventEmitter<boolean> = new EventEmitter<boolean>();
    private destroy: Subject<boolean> = new Subject<boolean>();
    public usersSelection = new SelectionModel<User>(true, []);

    constructor(
        protected fb: FormBuilder,
        protected messageService: MessageService,
        protected router: Router,
        protected notificationService: NotificationService
    ) {
        this.messageForm = this.fb.group({
            subject: [''],
            body: [''],
            media_ids: [[]],
            scope_id: [AppScope.USERS],
        });
    }
    ngOnInit(): void {
        if (this.navData.data.isMultipleUsers) {
            this.usersSelection.setSelection(...this.navData.data.models);
        }
    }
    toggleSelection(user: User): void {
        this.usersSelection.toggle(user);
    }

    // Check if a user is selected
    isSelected(user: User): boolean {
        return this.usersSelection.isSelected(user);
    }

    // Get the list of selected users
    getSelectedUsers(): User[] {
        return this.usersSelection.selected;
    }
    public submit() {
        if (!this.messageForm.value.subject) {
            return;
        }
        this.saving.emit(true);
        const message = new Notification(this.messageForm.value).getData();
        this.notificationService
            .create({
                ...message,
                ...(this.navData.data.isUser && { recipient_ids: [this.navData.data.model.id] }),
                ...(this.navData.data.isMultipleUsers && {
                    recipient_ids: this.getSelectedUsers().map((user) => user.id),
                }),
                ...(this.navData.data.isGroup && { group_ids: [this.navData.data.model.id] }),
            })
            .pipe(takeUntil(this.destroy))
            .subscribe(() => {
                this.onClose.emit(true);
                this.saving.emit(false);
                this.messageService.openMessage(
                    MessageErrorComponent,
                    this.navData.data.isMultipleUsers
                        ? $localize`Message sent`
                        : $localize`Message sent to ${this.navData.data.model.name}`
                );
            });
    }
    ngOnDestroy() {
        this.destroy.next(true);
        this.destroy.unsubscribe();
    }
}
